import { useEffect } from 'react';
import { useSidebarStore } from 'store/sidebar.store';

interface CollapseSidebarOptions {
  /** Focus mode also drops the shell header, so only pages that render their own should opt in. */
  focusMode?: boolean;
}

/** Restores on unmount, and only re-opens the nav if we were the ones who closed it. */
export function useCollapseSidebarOnMount({ focusMode = true }: CollapseSidebarOptions = {}): void {
  useEffect(() => {
    const { isOpen, setIsOpen, setFocusMode } = useSidebarStore.getState();
    const wasOpen = isOpen;
    if (focusMode) {
      setFocusMode(true);
    }
    if (wasOpen) {
      setIsOpen(false);
    }
    return () => {
      if (focusMode) {
        setFocusMode(false);
      }
      if (wasOpen) {
        setIsOpen(true);
      }
    };
  }, [focusMode]);
}
